  document.addEventListener('DOMContentLoaded', function () {
    const stickyQtyInput = document.querySelector('[data-sticky-qty]');
    const productForm = document.querySelector('form[action="/cart/add"]');

    if (!stickyQtyInput || !productForm) {
      console.warn('[Sticky ATC] Missing sticky quantity input or product form.');
      return;
    }

    const quantityInputInForm = productForm.querySelector('input[name="quantity"]');
    if (!quantityInputInForm) {
      console.warn('[Sticky ATC] No quantity input found inside the form.');
      return;
    }

    productForm.addEventListener('submit', function () {
      // Only sync if the user is on mobile
      if (window.innerWidth <= 768) {
        quantityInputInForm.value = stickyQtyInput.value;
        console.log('[Sticky ATC] Quantity set to:', stickyQtyInput.value);
      }
    });
  });
